import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const BreakDownCollections = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FETCH_BREAK_DOWN_COLLECTION
      .FETCH_DAY_WISE_BREAK_DOWN_COLLECTION:
      return { ...state, dayWiseBreakDownCollection: action.value };
    case actions.FETCH_BREAK_DOWN_COLLECTION.NAV_DATA:
      return { ...state, navData: action.value };
    case actions.FETCH_BREAK_DOWN_COLLECTION
      .FETCH_BREAK_DOWN_COLLECTION_SUMMARY:
      return { ...state, breakDownCollectionSummary: action.value };
    case actions.FETCH_BREAK_DOWN_COLLECTION.BREAK_DOWN_VIEW:
      return { ...state, breakDownView: action.value };
    default:
      return state;
  }
};

export default BreakDownCollections;
